import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azAksColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Cluster Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_aks"),

  resourceAccountColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.resource_group", headerName: "Resource Group" },

  { field: "resource.node_pool_count", headerName: "Node Pools Count" },

  { field: "resource.nodes_count", headerName: "Node Count" },

  { field: "resource.pricing_tier", headerName: "Pricing Tier" },

  {
    field: "resource.total_available_cpus",
    headerName: "Total Available CPUs",
  },

  {
    field: "resource.total_available_memory",
    headerName: "Total Available Memory",
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
